<template>
  <div class="flex-grow-1 account-list-container">
    <SubMenu
      class="pt-0 mt-0 pb-4 mb-4 d-flex justify-content-center account-list-container__submenu"
      :items="items"
      variant="horizontal"
    >
      <template slot-scope="{ item }">
        <router-link
          :to="{
            name: $route.name,
            params: { ...account.params, ...$route.params, tab: item.id },
          }"
        >
          <TextBlock
            :text="$t(item.key, item.labelActive || item.label, item.params)"
          />
        </router-link>
      </template>
    </SubMenu>
    <Panel v-if="currentComponent">
      <component :is="currentComponent" />
    </Panel>
    <div class="d-flex justify-content-center cta-navigation-button-wrapper">
      <router-link
        :to="{
          name: backRouteName,
          params: { ...account.params, ...$route.params },
        }"
      >
        <HeraFormBtn
          class="btn btn-secondary"
          variant="full-width"
          :label="$t('_web_tournament_back', 'Back')"
        />
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import SubMenu from '@/components/common/SubMenu';
import TextBlock from '@/components/atoms/TextBlock';
import Panel from '@/components/atoms/Panel';
import ROUTER_NAMES_ACCOUNT from '@/constants/router/account';
import HeraFormBtn from '@/components/atoms/HeraFormBtn';

const Members = () => import('./Members');
const Followers = () => import('./Followers');
const Invitations = () => import('./Invitations');
// const Requests = () => import('./Requests'); // backend not ready

export default {
  name: 'ManageClan',
  components: {
    SubMenu,
    TextBlock,
    Panel,
    HeraFormBtn,
  },
  computed: {
    ...mapState('current', ['account']),
    backRouteName() {
      return ROUTER_NAMES_ACCOUNT.ACCOUNT;
    },
    currentTab() {
      return this.$route.params.tab;
    },
    currentComponent() {
      return (
        this.items.filter(i => i.id === this.currentTab)[0].component || null
      );
    },
    items() {
      const { countsStrings } = this.account;

      const tabs = [
        {
          id: 'members',
          label: 'Members',
          labelActive: 'Members ({members})',
          key: '_web_clan-manage_members-tab',
          component: Members,
          params: countsStrings,
        },
        {
          id: 'followers',
          label: 'Followers',
          labelActive: 'Followers ({followers})',
          key: '_web_clan-manage_followers-tab',
          component: Followers,
          params: countsStrings,
        },
      ];
      if (this.account.canManage) {
        tabs.push({
          id: 'invitations',
          label: 'Invitations',
          key: '_web_clan-manage_invitations-tab',
          component: Invitations,
        });
        // TODO: list requests has only logins users, will be implemented after fix on backend
        // tabs.push({
        //   id: 'requests',
        //   label: 'Requests',
        //   key: '_web_clan-manage_requests-tab',
        //   component: Requests,
        //   params: countsStrings,
        // });
      }
      return tabs;
    },
  },
};
</script>

<style lang="scss">
.account-list-container__submenu {
  background-color: $new-bg-page;
}
@media (max-width: 767px) {
  .account-list-container__submenu {
    gap: 6px;
    flex-direction: column !important;
    .list-group__item-expander {
      flex: 0 0 0px !important;
    }
    li {
      flex-grow: 1;
      min-width: unset !important;

      a {
        padding: 10px 3px !important;
        height: 100%;
      }
    }
  }
}
</style>
